import { render, staticRenderFns } from "./ShuttleBox.vue?vue&type=template&id=aa2b8148&scoped=true&"
import script from "./ShuttleBox.vue?vue&type=script&lang=js&"
export * from "./ShuttleBox.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleBox.vue?vue&type=style&index=0&id=aa2b8148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2b8148",
  null
  
)

export default component.exports